var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRunning = function SvgRunning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#14161A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.5a1 1 0 0 0-2 0v5a1 1 0 1 0 2 0v-5Zm4 0a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z",
    fill: "#fff"
  })));
};
export { SvgRunning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMxNDE2MUEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDUuNUM3IDQuOTQ3NzIgNi41NTIyOCA0LjUgNiA0LjVDNS40NDc3MiA0LjUgNSA0Ljk0NzcyIDUgNS41VjEwLjVDNSAxMS4wNTIzIDUuNDQ3NzIgMTEuNSA2IDExLjVDNi41NTIyOCAxMS41IDcgMTEuMDUyMyA3IDEwLjVWNS41Wk0xMSA1LjVDMTEgNC45NDc3MiAxMC41NTIzIDQuNSAxMCA0LjVDOS40NDc3MiA0LjUgOSA0Ljk0NzcyIDkgNS41VjEwLjVDOSAxMS4wNTIzIDkuNDQ3NzIgMTEuNSAxMCAxMS41QzEwLjU1MjMgMTEuNSAxMSAxMS4wNTIzIDExIDEwLjVWNS41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";